<div class="task-calendar-container">
  <!-- Calendar Header -->
  <div class="calendar-header">
    <div class="calendar-controls">
      <button pButton pRipple type="button" icon="pi pi-chevron-left"
        class="p-button-text p-button-sm" (click)="previousMonth()"
        [disabled]="loading"
      label="Previous"></button>
      <button pButton pRipple type="button"
        class="p-button-text p-button-sm" (click)="goToToday()"
        [disabled]="loading"
      label="Today"></button>
      <button pButton pRipple type="button" icon="pi pi-chevron-right"
        iconPos="right" class="p-button-text p-button-sm" (click)="nextMonth()"
        [disabled]="loading"
      label="Next"></button>
      <h3 class="calendar-month-title">{{ currentMonth.format('MMMM YYYY') }}</h3>
    </div>
    <div class="calendar-view-mode">
      <label class="view-mode-label">View by:</label>
      <p-dropdown [options]="viewModeOptions" [(ngModel)]="calendarViewMode"
        optionLabel="label" optionValue="value"
        dropdownIcon="fa fa-caret-down"
        (onChange)="onViewModeChange()"
        [disabled]="loading"
      [style]="{'min-width': '150px'}"></p-dropdown>
    </div>
  </div>

  <!-- Calendar Grid -->
  <div class="calendar-grid-wrapper">
    <!-- Loading Overlay -->
    @if (loading) {
      <div class="calendar-loading-overlay">
        <div class="loading-content">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
          <p>Loading tasks for {{ currentMonth.format('MMMM YYYY') }}...</p>
        </div>
      </div>
    }

    <!-- Calendar Grid -->
    <div class="calendar-grid">
      <!-- Weekday Headers -->
      <div class="calendar-weekdays">
        @for (day of ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']; track day) {
          <div class="calendar-weekday">
            {{ day }}
          </div>
        }
      </div>

      <!-- Calendar Days -->
      @for (week of weeks; track week) {
        <div class="calendar-week"
          [class.has-tasks]="week.hasTasks"
          >
          @for (day of week.days; track day) {
            <div class="calendar-day"
              [class.other-month]="!day.isCurrentMonth"
              [class.today]="day.isToday"
              [class.no-tasks]="day.tasks.length === 0"
              >
              <div class="day-number">{{ day.date.format('D') }}</div>
              <div class="day-tasks">
                @for (task of getVisibleTasksForDate(day.date); track task; let i = $index) {
                  <div class="task-card"
                    [class]="getPriorityClass(task)"
                    [class.subtask-card]="isSubTask(task)"
                    [style.border-left-color]="getTaskColor(task)"
                    (click)="onTaskClick(task, $event)"
                    (dblclick)="onTaskDoubleClick(task, $event)"
                    (contextmenu)="openCm($event, gf, task)"
                    [title]="task.name">
                    <div class="task-card-content">
                      <div class="task-card-header">
                        <span class="task-id">
                          @if (isSubTask(task)) {
                            <i class="pi pi-sitemap subtask-icon" title="Sub-task"></i>
                          }
                          #{{ task.taskId }}
                        </span>
                      </div>
                      <div class="task-card-body">
                        <span class="task-name">{{ task.name }}</span>
                        @if (isSubTask(task) && getParentTaskDisplayName(task)) {
                          <span class="parent-task-indicator clickable"
                            (click)="onParentTaskClick(task, $event)"
                            [title]="'Click to open parent task'">
                            <i class="pi pi-arrow-up"></i>
                            {{ getParentTaskDisplayName(task) }}
                          </span>
                        }
                      </div>
                      @if (task.assignedTo) {
                        <div class="task-card-footer">
                          <span class="task-assigned">
                            <i class="pi pi-user"></i>
                            {{ fullName(task.assignedTo) }}
                          </span>
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (day.tasks.length > 2 && !isDateExpanded(day.date.format('YYYY-MM-DD'))) {
                  <div class="more-tasks"
                    (click)="onMoreTasksClick(day.date, $event)">
                    +{{ day.tasks.length - 2 }} more
                  </div>
                }
                @if (day.tasks.length > 2 && isDateExpanded(day.date.format('YYYY-MM-DD'))) {
                  <div class="show-less"
                    (click)="onShowLessClick(day.date, $event)">
                    Show less
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  <!-- Legend -->
  <div class="calendar-legend">
    <div class="legend-item">
      <span class="legend-color" style="background-color: #dc3545;"></span>
      <span>Overdue</span>
    </div>
    <div class="legend-item">
      <span class="legend-color" style="background-color: #ffc107;"></span>
      <span>Due Today</span>
    </div>
    <div class="legend-item">
      <span class="legend-color" style="background-color: #fd7e14;"></span>
      <span>Due Soon (1-3 days)</span>
    </div>
    <div class="legend-item">
      <span class="legend-color" style="background-color: #17a2b8;"></span>
      <span>Normal</span>
    </div>
    <div class="legend-item">
      <span class="legend-color" style="background-color: #28a745;"></span>
      <span>Completed</span>
    </div>
  </div>
  <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
</div>

<p-dialog header="Summary" [(visible)]="showOpenSummary" [style]="{width: '30vw'}">
  @if (taskApiData) {
    <app-task-summary [task]="taskApiData"></app-task-summary>
  }
</p-dialog>

